// credit: https://sanity-io-land.slack.com/archives/C9Z7RC3V1/p1606155909114100?thread_ts=1606155317.113300&cid=C9Z7RC3V1
const toPlainText = (blocks) => {
  if (!blocks) return null;
  return (
    blocks
      .map((block) => {
        // if it's not a text block with children,
        // return nothing
        if (block._type !== 'block' || !block.children) {
          return '';
        }
        // loop through the children spans, and join the
        // text strings
        return block.children.map((child) => child.text).join('');
      })
      // join the paragraphs leaving split by two linebreaks
      .join('\n\n')
  );
};

module.exports = { toPlainText };
